import { createContext, use } from 'react'

export interface EditorActions {
  format: () => void
  reset: () => void
  /** Replace the editor content with the given code string */
  setCode: (value: string) => void
  /** Run code against visible test cases (from Test Cases pane) */
  run: () => void
  /** Run raw code without test harness (interview mode) */
  runRaw: () => void
  /** Submit code for full evaluation (all test cases from DB) */
  submit: () => void
  isExecuting: boolean
  isSubmitting: boolean
  isFormatting: boolean
}

const noop = () => {}

const defaultActions: EditorActions = {
  format: noop,
  reset: noop,
  setCode: noop,
  run: noop,
  runRaw: noop,
  submit: noop,
  isExecuting: false,
  isSubmitting: false,
  isFormatting: false,
}

const EditorActionsContext = createContext<EditorActions>(defaultActions)

export function EditorActionsProvider({
  actions,
  children,
}: {
  actions: EditorActions
  children: React.ReactNode
}) {
  return <EditorActionsContext value={actions}>{children}</EditorActionsContext>
}

export function useEditorActions() {
  return use(EditorActionsContext)
}
